// WCM - Weborama Campaign Manager

const putWeboramaUserSyncPixel = (): void => {
    const pixel = new Image();
    const idCollectorURL = `https://${window.location.host}/shards/vendor_user_sync?weborama_user_id={WEBO_ID}`;
    pixel.src = `https://redirect.frontend.weborama.fr/rd?url=${encodeURIComponent(idCollectorURL)}`;
    pixel.style.display = 'none';
    document.body.appendChild(pixel);
};

export const WcmConversionIdAlias = {
    /* eslint-disable @typescript-eslint/naming-convention */
    HH_B2B_PAGE: '1',
    HH_AUTHORIZATION_EMPLOYER: '2',
    HH_REGISTRATION_CLIENT: '3',
    HH_ALL_SITE: '4',
    HH_AUTHORIZATION_SOISKATEL: '5',
    HH_REGISTRATION_SOISKATEL: '6',
    HH_B2C_CO_BRAND_START_OTCLICK: '18',
    /* eslint-enable @typescript-eslint/naming-convention */
} as const;

export type WcmConversionId = (typeof WcmConversionIdAlias)[keyof typeof WcmConversionIdAlias];

export const sendWcmConversion = (conversionId: WcmConversionId): void => {
    const WCM_ID = '8899';
    const pixel = new Image();
    pixel.src = `https://wcm-ru.frontend.weborama.fr/fcgi-bin/dispatch.fcgi?a.A=co&a.si=${WCM_ID}&a.cp=${conversionId}&a.ct=d`;
    if (conversionId === WcmConversionIdAlias.HH_B2C_CO_BRAND_START_OTCLICK) {
        pixel.src += `&g.cb=${Math.random()}`;
    }
    pixel.width = 1;
    pixel.height = 1;
    pixel.style.display = 'none';
    document.body.appendChild(pixel);
    if (conversionId === WcmConversionIdAlias.HH_ALL_SITE) {
        putWeboramaUserSyncPixel();
    }
};
